import { ActionIcon, Menu } from "@mantine/core";
import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    void i18n.changeLanguage(lang);
  };

  return (
    <Menu shadow="md" width={150}>
      <Menu.Target>
        <ActionIcon
          variant="default"
          size="lg"
          aria-label={t("nav.langSwitch")}
          title={t("nav.langSwitch")}
          data-testid="language-switcher-button"
        >
          <Languages size={20} strokeWidth={1.5} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>{t("nav.language")}</Menu.Label>
        <Menu.Item
          onClick={() => handleLanguageChange("en")}
          fw={i18n.language === "en" ? 700 : 400}
          aria-current={i18n.language === "en" ? "true" : undefined}
          data-testid="language-switcher-en"
        >
          {t("nav.langEn")}
        </Menu.Item>
        <Menu.Item
          onClick={() => handleLanguageChange("es")}
          fw={i18n.language === "es" ? 700 : 400}
          aria-current={i18n.language === "es" ? "true" : undefined}
          data-testid="language-switcher-es"
        >
          {t("nav.langEs")}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
